/**
 * Utility functions for formatting employee names on the storefront (client-facing).
 */
export const formatEmployeeNameForClient = (employee) => {
  if (typeof employee === 'string') {
    const nameParts = employee.trim().split(/\s+/);
    if (nameParts.length >= 2) {
      const firstName = nameParts[0];
      const lastNameInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
      return `${firstName} ${lastNameInitial}`;
    }
    return nameParts[0] || employee;
  }

  if (!employee) {
    return 'Staff Member';
  }

  if (employee.isAnyAvailable || employee.name === 'Any Available') {
    return 'Any Available';
  }

  if (employee.firstName && employee.lastName) {
    const firstName = employee.firstName.trim();
    const lastNameInitial = employee.lastName.trim().charAt(0).toUpperCase();
    return `${firstName} ${lastNameInitial}`;
  }

  if (employee.firstName) {
    return employee.firstName.trim();
  }

  if (employee.name) {
    const nameParts = employee.name.trim().split(/\s+/);
    if (nameParts.length >= 2) {
      const firstName = nameParts[0];
      const lastNameInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
      return `${firstName} ${lastNameInitial}`;
    }
    return nameParts[0] || employee.name;
  }

  return 'Staff Member';
};

export const getEmployeeInitial = (employee) => {
  const firstName = formatEmployeeNameForClient(employee);
  if (firstName === 'Any Available') {
    return 'A';
  }
  return firstName.charAt(0).toUpperCase() || 'S';
};

export const getEmployeeInitials = (employee) => {
  if (!employee) return 'SM';
  
  if (employee.isAnyAvailable || employee.name === 'Any Available') {
    return 'AA';
  }

  if (employee.firstName && employee.lastName) {
    return `${employee.firstName[0]}${employee.lastName[0]}`.toUpperCase();
  }
  
  if (employee.firstName) {
    return `${employee.firstName[0]}${employee.firstName[1] || employee.firstName[0]}`.toUpperCase();
  }
  
  if (employee.name) {
    const nameParts = employee.name.trim().split(/\s+/);
    if (nameParts.length >= 2) {
      return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase();
    }
    return employee.name.substring(0, 2).toUpperCase() || 'SM';
  }
  
  return 'SM';
};
